import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import MUIDataTable from "mui-datatables";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import SearchIcon from "@material-ui/icons/Search";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import Button from "components/CustomButtons/Button.jsx";
// import Initial from "react-initial";
import { pushLoader } from "actions/main";
import { pushMydata } from "actions/dashboard";
import {
  fetchDataTable,
  pushUpdateStars,
  pushUpdateStarsGlob,
  pushAddFav,
  deleteFav
} from "../../api/marketplace";
import Config from "../../config/";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";
import { withRouter } from "react-router-dom";

const ROOT_URL = Config.rooturl;
const styles = {
  title: {
    display: "inline-block",
    margin: "2px 2px",
    paddingLeft: "2px"
  }
};

class Marketplace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: [],
      search: "",
      buttonFav: true,
      // colorFav: "secondary",
      stacked: true
    };
  }

  UNSAFE_componentWillMount() {
    fetchDataTable()
      .then(response => {
        this.setState({ datatable: response.data.results });
        this.props.pushMydata(response.data.results);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps() {
    fetchDataTable()
      .then(response => {
        this.setState({ datatable: response.data.results });
        this.props.pushMydata(response.data.results);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  updateStars = (event, meta) => {
    this.props.pushLoader(true);
    pushUpdateStars(event, meta.rowData)
      .then(() => {
        this.props.pushLoader(false);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    pushUpdateStarsGlob(event, meta.rowData)
      .then(() => {
        this.props.pushLoader(false);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  addFavorite = meta => {
    if (this.state.buttonfav != true) {
      pushAddFav(meta.rowData[0]);
      this.setState({
        buttonFav: !this.state.buttonFav
      });
    } else {
      deleteFav(meta.rowData[0]);
      this.setState({
        buttonFav: this.state.buttonFav
      });
    }
  };

  render() {
    const columns = [
      {
        name: "id",
        label: "id",
        options: { filter: false, display: false }
      },
      {
        label: "File Name",
        name: "file_title",
        options: {
          filter: true,
          customBodyRender: name => {
            return (
              <Typography component={"span"} noWrap={true}>
                <div>
                  {/* <Initial name={name} fontSize="18" height="30" width="30" />  */}
                  <span style={styles.title}>{name}</span>
                </div>
              </Typography>
            );
          }
        }
      },
      {
        name: "author",
        label: "Author",
        options: { filter: false }
      },
      {
        name: "downloaded",
        label: "Downloaded",
        options: { filter: false }
      },
      {
        name: "price",
        label: "Price",
        options: {
          filter: true,
          customBodyRender: value => {
            const nf = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return nf.format(value);
          }
        }
      },
      {
        name: "stars",
        label: "Rating",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Typography component={"div"} noWrap={true}>
                <div>.

                </div>
              </Typography>
            );
          }
        }
      },
      {
        name: "user_id",
        label: "user_id",
        options: { filter: false, display: false }
      },
      {
        name: "date_created",
        label: "date_created",
        options: { filter: false, display: true }
      },
      {
        name: "dataseturl",
        label: "dataseturl",
        options: {
          filter: true,
          display: true,
          customBodyRender: (value, tableMeta) => {
            return <a href={ROOT_URL + value}>Download</a>;
          }
        }
      },
      {
        name: "favorite",
        label: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>
                <Button
                  justIcon
                  round
                  color={this.state.buttonFav ? "secondary" : "primary"}
                  // onClick={() =>
                  //   window.alert(`Clicked "Edit" for row ${tableMeta.rowIndex}`)
                  // }
                  onClick={() => this.addFavorite(tableMeta)}
                >
                  <FavoriteBorderIcon />
                </Button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      selectableRows: "none",
      responsive: this.state.stacked ? "stacked" : "scrollMaxHeight"
    };

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <h3>Marketplace</h3>
          <CustomInput
            id="search"
            inputProps={{
              placeholder: "Search",
              value: this.state.search,
              onChange: e => {
                this.setState({ search: e.target.value });
              }
            }}
          />
          <Button justIcon round color="primary">
            <SearchIcon />
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            headerColor="plain"
            tabs={[
              {
                tabName: "Data Library",
                tabContent: (
                  <MUIDataTable
                    data={this.state.datatable}
                    columns={columns}
                    options={options}
                  />
                )
              },
              {
                tabName: "Favorites",
                tabContent: <p>setting</p>
              }
            ]}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Marketplace.propTypes = {
  pushLoader: PropTypes.string,
  pushMydata: PropTypes.object
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader
  };
}

export default withRouter(withStyles(styles)(
  connect(
    mapStateToProps,
    { pushLoader, pushMydata }
  )(Marketplace)
));
